$(function () {
  $('.swipebox, img.zoombox').zoombox();
})
